import { useCallback } from 'react'
import { TableColumnPreferences, userPreferencesStore } from '../stores/UserPreferencesStore'

export type TableColumnPreferencesData = {
  columnVisibility?: Record<string, boolean>
  columnOrder?: string[]
}

export const useTablePreferencesConfig = (preferenceKey: string) => {
  const savedPreferences = userPreferencesStore.isLoaded
    ? userPreferencesStore.getTablePreferences(preferenceKey)
    : undefined
  const onPreferencesChange = useCallback(
    (prefs: TableColumnPreferencesData) =>
      userPreferencesStore.setTablePreferences(preferenceKey, prefs),
    [preferenceKey],
  )
  return { savedPreferences, onPreferencesChange }
}
